import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from 'src/app/shared/services/base-api.service';
import { environment } from 'src/environments/environment';
import { NotificationDto } from '../../data-models/notification.data.models';

@Injectable({
  providedIn: 'root'
})
export class NotificationDataService {
  private controllerUrl: string = `${environment.appConfig.gatewayServiceBaseUrl}/api/1/Notifications/`;

  constructor(private baseApi: BaseApiService<any>) {}

  GetNotificationsList(pageIndex: number, pageSize: number): Observable<any> {
    return this.baseApi.Get(`${this.controllerUrl}GetNotificationsList?pageIndex=${pageIndex}&pageSize=${pageSize}`);
  }

  GetNotificationDetails(notificationId: string): Observable<any> {
    return this.baseApi.Get(`${this.controllerUrl}GetNotificationDetails?notificationId=${notificationId}`);
  }

  GetUnreadNotificationsCount(): Observable<any> {
    return this.baseApi.Get(`${this.controllerUrl}GetUnreadNotificationsCount`);
  }

  ReadNotification(notificationId: string): Observable<any> {
    return this.baseApi.Put(`${this.controllerUrl}ReadNotification?notificationId=${notificationId}`, {});
  }

  ReadAll(): Observable<any> {
    return this.baseApi.Put(`${this.controllerUrl}ReadAll`, {});
  }
}
